import {
  LAYOUTS,
  MENU_SECTIONS,
  MODULE_SETTINGS,
  USER_ROLES,
} from "shared/constants";
import type { AppRouteRecordRaw } from "shared/types";
import { MEETING_TYPES } from "meetings/shared/constants";
import { meetingKey } from "meetings/student/utils/meetingKey";
import { STUDENT_MEETING_ROUTE_NAMES } from "./routeNames";

const routes: AppRouteRecordRaw[] = [
  {
    path: "/my-feedback",
    name: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK,
    component: () => import("meetings/student/pages/StudentMyFeedbackPage.vue"),
    meta: {
      title: "Mijn feedback",
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      exactRouteIdentifier: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK,
      roleRequired: [USER_ROLES.STUDENT],
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      isMenuItem: true,
      menuSection: MENU_SECTIONS.MAIN,
      menuOrder: 7,
      icon: "/images/menu/feedback.svg",
      studentView: true,
      hideTitle: true,
    },
  },
  // The meetings open as cards on the overview; these old detail URLs (still
  // targeted by notifications and bookmarks) open that meeting's card.
  {
    path: "/my-feedback/:id",
    name: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK_DETAIL,
    redirect: (to) => ({
      name: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK,
      params: {},
      query: {
        open: meetingKey({
          meetingType: MEETING_TYPES.MEETING,
          id: String(to.params.id),
        }),
      },
    }),
  },
  {
    path: "/my-feedback/transition/:id",
    name: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK_TRANSITION_DETAIL,
    redirect: (to) => ({
      name: STUDENT_MEETING_ROUTE_NAMES.MY_FEEDBACK,
      params: {},
      query: {
        open: meetingKey({
          meetingType: MEETING_TYPES.TRANSITION_MEETING,
          id: String(to.params.id),
        }),
      },
    }),
  },
];

export default routes;
